import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import { RoleHelper } from "@/helpers";
var propertyView = false;

var Authentication =
/*#__PURE__*/
function () {
  function Authentication() {
    _classCallCheck(this, Authentication);
  }

  _createClass(Authentication, null, [{
    key: "Login",
    value: function Login(username, password, ad, impersonateAs) {
      var me = this;
      return new Promise(function (resolve, reject) {
        axios({
          method: "post",
          url: "/api/users/authenticate",
          data: {
            userName: username,
            password: password
          },
          headers: {
            "Content-type": "application/json"
          }
        }).then(function (response) {
          me.SetUserData(response.data);
          me.IsManager().then(function (resp) {
            me.SetIsManager(resp.data);
            resolve(response);
          });
        }).catch(function (ex) {
          if (ex.response) reject(ex.response.data.error_description);else reject("Error Contacting Server");
        });
      });
    }
  }, {
    key: "ForgotPassword",
    value: function ForgotPassword(userName) {
      return new Promise(function (resolve, reject) {
        axios({
          method: "GET",
          url: "/api/users/ForgotPassword",
          params: {
            userName: userName
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "ResendInvite",
    value: function ResendInvite(userName) {
      return axios({
        method: "GET",
        url: "/api/users/ResendInvite",
        params: {
          userName: userName
        }
      });
    }
  }, {
    key: "ForgotUserName",
    value: function ForgotUserName(email) {
      return new Promise(function (resolve, reject) {
        axios({
          method: "GET",
          url: "/api/Account/ForgotUserName",
          params: {
            email: email
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "ResetPasswordTokenIsValid",
    value: function ResetPasswordTokenIsValid(userName, token) {
      return new Promise(function (resolve, reject) {
        axios.post("/api/users/ValidatePasswordResetToken", {
          userName: userName,
          token: token
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "ResetPassword",
    value: function ResetPassword(userName, password, confirmPassword, token) {
      return new Promise(function (resolve, reject) {
        axios.post("/api/users/ResetPassword", {
          userName: userName,
          password: password,
          confirmPassword: confirmPassword,
          token: token
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "ChangePassword",
    value: function ChangePassword(userName, currentPassword, newPassword) {
      return new Promise(function (resolve, reject) {
        axios.post("/api/Account/UpdatePassword", {
          userName: userName,
          currentPassword: currentPassword,
          newPassword: newPassword
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          if (ex.response.data.ModelState) {
            var error = "";

            for (var i in ex.response.data.ModelState) {
              var state = ex.response.data.ModelState[i];
              error += state.join(".");
            }

            reject(error);
          } else {
            reject(ex);
          }
        });
      });
    }
  }, {
    key: "GetUserInfo",
    value: function GetUserInfo(userName) {
      return new Promise(function (resolve, reject) {
        axios({
          method: "get",
          url: "/api/UserProfile",
          params: {
            userName: userName
          },
          doNotShowLoading: true
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "RefreshToken",
    value: function RefreshToken() {
      var me = this;
      return new Promise(function (resolve, reject) {
        axios({
          method: "Post",
          url: "/api/users/Refresh",
          data: qs.stringify({
            token: Authentication.GetToken(),
            refreshToken: Authentication.GetRefreshToken()
          }),
          headers: {
            "content-type": "application/x-www-form-urlencoded"
          },
          doNotShowLoading: true
        }).then(function (response) {
          var data = response.data;

          if (!data || !data.token) {
            reject();
          }

          var userData = Authentication.GetUserData();
          userData.token = data.token;
          userData.refreshToken = data.refreshToken;
          Authentication.SetUserData(userData);
          Authentication.IsManager().then(function (resp) {
            Authentication.SetIsManager(resp.data);
            resolve(response.data);
          });
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "IsManager",
    value: function IsManager() {
      return new Promise(function (resolve, reject) {
        axios({
          method: "get",
          url: "/api/users/IsManager",
          doNotShowLoading: true
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          reject(ex);
        });
      });
    }
  }, {
    key: "HasReadPropertyPermission",
    value: function HasReadPropertyPermission(perm, propertyId) {
      var permissions = this.GetUserPermission();
      if (this.IsMCSuperUserForProperty(propertyId)) return true;

      if (permissions && permissions.length > 0) {
        var property = permissions.find(function (x) {
          return x.propertyId == propertyId && x.key == perm && (x.write || x.read);
        });
        var isGlobalAdmin = permissions.find(function (x) {
          return x.propertyId == propertyId && x.key == "Global_Admin" && (x.write || x.read);
        });
        return property || isGlobalAdmin;
      }

      return false;
    }
  }, {
    key: "HasWritePropertyPermission",
    value: function HasWritePropertyPermission(perm, propertyId) {
      var permissions = this.GetUserPermission();
      if (this.IsMCSuperUserForProperty(propertyId)) return true;

      if (permissions && permissions.length > 0) {
        var property = permissions.find(function (x) {
          return x.propertyId == propertyId && x.key == perm && x.write;
        });
        var isGlobalAdmin = permissions.find(function (x) {
          return x.propertyId == propertyId && x.key == "Global_Admin" && x.write;
        });
        return property || isGlobalAdmin;
      }

      return false;
    }
  }, {
    key: "HasReadPermission",
    value: function HasReadPermission(perm) {
      var permissions = this.GetUserPermission();
      if (this.IsMCSuperUser()) return true;
      if (permissions && permissions.length > 0) return permissions.find(function (x) {
        return (x.key == perm || x.key == "Global_Admin") && (x.write || x.read);
      }) != null;else return false;
    }
  }, {
    key: "HasWritePermission",
    value: function HasWritePermission(perm) {
      var permissions = this.GetUserPermission();
      if (this.IsMCSuperUser()) return true;
      if (permissions && permissions.length > 0) return permissions.find(function (x) {
        return (x.key == perm || x.key == "Global_Admin") && x.write;
      }) != null;else return false;
    }
  }, {
    key: "GetUserType",
    value: function GetUserType() {
      var user = this.GetUserData();
      if (user) return user.roles;else return null;
    }
  }, {
    key: "IsMHDCUser",
    value: function IsMHDCUser(overridePropertyView) {
      return (!propertyView || overridePropertyView == true) && (this.IsMHDCAdmin(overridePropertyView) || this.IsMHDCReadOnly(overridePropertyView));
    }
  }, {
    key: "IsMHDCAdmin",
    value: function IsMHDCAdmin(overridePropertyView) {
      if (propertyView && !overridePropertyView) return false;
      var roles = this.GetUserType();
      if (!roles) return false;
      return roles.find(function (x) {
        return x.id == RoleHelper.ROLES.MHDC_WRITE.value;
      }) != null;
    }
  }, {
    key: "IsMHDCReadOnly",
    value: function IsMHDCReadOnly(overridePropertyView) {
      if (propertyView && !overridePropertyView) return false;
      var roles = this.GetUserType();
      if (!roles) return false;
      return roles.find(function (x) {
        return x.id == RoleHelper.ROLES.MHDC_READ.value;
      }) != null;
    }
  }, {
    key: "IsMCSuperUser",
    value: function IsMCSuperUser() {
      var user = this.GetUserData();
      return user && (user.isMcAdmin || user.mainUserProject && user.mainUserProject.length > 0);
    }
  }, {
    key: "IsMCSuperUserForProperty",
    value: function IsMCSuperUserForProperty(propertyId) {
      var user = this.GetUserData();
      return user.mainUserProject.indexOf(propertyId) >= 0;
    }
  }, {
    key: "GetUserPermission",
    value: function GetUserPermission() {
      var user = this.GetUserData();
      if (user) return user.permissions;else return null;
    }
  }, {
    key: "GetUserName",
    value: function GetUserName() {
      var user = this.GetUserData();
      if (user) return user.name;else return null;
    }
  }, {
    key: "GetUserProperties",
    value: function GetUserProperties() {
      var user = this.GetUserData();
      if (user) return user.projects;else return null;
    }
  }, {
    key: "GetUserEmail",
    value: function GetUserEmail() {
      var user = this.GetUserData();
      if (user) return user.email;else return null;
    }
  }, {
    key: "GetUserId",
    value: function GetUserId() {
      var user = this.GetUserData();
      if (user) return user.userId;else return null;
    }
  }, {
    key: "LogOut",
    value: function LogOut() {
      var me = this;
      return new Promise(function (resolve, reject) {
        me.SetPropetyView(false);
        me.SetUserData(null);
        me.SetIsManager(false);
        resolve(true);
      });
    }
  }, {
    key: "SetUserData",
    value: function SetUserData(UserData) {
      return LocalStorage.set("UserData", UserData);
    }
  }, {
    key: "SetIsManager",
    value: function SetIsManager(IsManager) {
      return LocalStorage.set("IsManager", IsManager);
    }
  }, {
    key: "GetIsManager",
    value: function GetIsManager() {
      var IsManager = LocalStorage.getItem("IsManager");
      if (IsManager) return IsManager;else return false;
    }
  }, {
    key: "GetUserData",
    value: function GetUserData() {
      return LocalStorage.getItem("UserData");
    }
  }, {
    key: "SetPropetyView",
    value: function SetPropetyView(value) {
      propertyView = value;
    }
  }, {
    key: "GetPropertyView",
    value: function GetPropertyView() {
      return propertyView;
    }
  }, {
    key: "GetToken",
    value: function GetToken() {
      var user = this.GetUserData();
      if (user) return user.token;else return null;
    }
  }, {
    key: "GetRefreshToken",
    value: function GetRefreshToken() {
      var user = this.GetUserData();
      if (user) return user.refreshToken;else return null;
    }
  }, {
    key: "TokenValid",
    value: function TokenValid() {
      var token = this.GetToken();
      return token && new Date(this.GetUserData().expires_at) > new Date();
    }
  }]);

  return Authentication;
}();

export { Authentication as default };